import HomeBanner3D from "./three/HomeBanner3D";

document.addEventListener("DOMContentLoaded", () => {
	const root = document.querySelector("[data-home-3d]");
	if (!root) return;

	new HomeBanner3D(root);
});
